import { render, staticRenderFns } from "./Reference.vue?vue&type=template&id=5f9ac6e7&lang=pug&"
import script from "./Reference.vue?vue&type=script&lang=js&"
export * from "./Reference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f9ac6e7')) {
      api.createRecord('5f9ac6e7', component.options)
    } else {
      api.reload('5f9ac6e7', component.options)
    }
    module.hot.accept("./Reference.vue?vue&type=template&id=5f9ac6e7&lang=pug&", function () {
      api.rerender('5f9ac6e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/docs/Reference.vue"
export default component.exports